"use client";

import dynamic from "next/dynamic";

const Chatbot = dynamic(() => import("@/app/chatbot"), { ssr: false });
const StartChat = dynamic(() => import("../StartChat/StartChat"), { ssr: false });

export default function ChatbotDeferred() {
  return (
    <>
      <Chatbot />
      <StartChat />
    </>
  );
}
